import FormGroup from '@maison/components/form/FormGroup.vue';
import SelectField from '@maison/components/form/fields/SelectField.vue';
import { set, has, get } from 'lodash-es';
import { mapState } from 'vuex';

export default {
  components: { SelectField, FormGroup },

  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      prefectures: [],
    };
  },

  computed: {
    ...mapState('form', ['dynamicFields']),

    fields: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  watch: {
    'fields.address9.options'(value) {
      if (value.length === 0) {
        this.setOptionsAndValues(this.dynamicFields);
      }
    },

    dynamicFields: {
      handler(value) {
        this.setOptionsAndValues(value);
      },
      immediate: true,
      deep: true,
    },

    'fields.address9.value'(value) {
      this.setCityOptions(value);
    },

    'fields.address7.value'(value) {
      this.setDistrictOptions(value);
    },
  },

  methods: {
    setOptionsAndValues(dynamicValues) {
      if (has(dynamicValues, 'CN.prefectures')) {
        this.setPrefectureOptions(dynamicValues.CN.prefectures);
        if (this.fields.address9.value) {
          this.setCityOptions(this.fields.address9.value);
        }
        if (this.fields.address7.value) {
          this.setDistrictOptions(this.fields.address7.value);
        }
      }
    },

    setOptions(field, parentValues, value = true) {
      const options = value
        ? Object.keys(parentValues).map((item) => ({
            value: item,
            label: item,
          }))
        : [];
      set(this.fields, [field, 'options'], options);
    },

    clearData(field, value) {
      if (
        this.fields[field].value &&
        (!value || !this.fields[field].options.map((item) => item.value).includes(this.fields[field].value))
      ) {
        set(this.fields, [field, 'value'], '');
      }
    },

    setPrefectureOptions(prefectures) {
      this.prefectures = prefectures;
      this.setOptions('address9', this.prefectures);
    },

    setCityOptions(prefecture) {
      this.setOptions('address7', get(this.prefectures, [prefecture], []), prefecture);
      this.clearData('address7', prefecture);
    },

    setDistrictOptions(city) {
      this.setOptions('address8', get(this.prefectures, [this.fields.address9.value, city], []), city);
      this.clearData('address8', city);
    },
  },
};
